// packages
import { Component, h } from 'preact';

// components
import CandidateRow from '../components/CandidateRow';
import Contest from '../components/Contest';
import Portal from '../components/Portal';

// import { determineContestTitle } from './election-utils';
import { RESULTS_IN_USE, visibleCandidateCount } from '../endpoints';
import getJSON from '../utils/get-json';

type State = {
  race: { [key: string]: any };
};

class StatewideRaces extends Component<{}, State> {
  //   timer!: number;

  constructor() {
    super();

    this.state = {
      race: [],
    };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {

    getJSON(RESULTS_IN_USE).then(data => {
      let statewide_races = [
        'President',
        'U.S. Senate',
        'Texas Railroad Commission',
        'Texas Supreme Court',
        'Texas Court of Criminal Appeals',
      ];

      const race = data.filter(function(e) {
        return this.indexOf(e.office) !== -1;
      }, statewide_races);

      this.setState({ race });
    });
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
                         }

  componentDidUpdate() {
  }

  render() {
    const { race } = this.state;

    return (
      <Portal
        node={document.querySelector('#statewide__contests')}
        ref={ref => (this._usPortal = ref)}
      >
        <div class="statewide-races-viewer t-sans">
          {race.map(contest => (
            <Contest
              race={contest}
              visibleCandidateCount={visibleCandidateCount}
              statewideRace={true}
              renderCandidate={(candidate, idx, viewAllCandidates) => (
                <CandidateRow
                  partyName={candidate.party}
                  candidate={candidate}
                  ballotName={candidate.name}
                  isIncumbent={candidate.is_incumbent}
                  isViewable={viewAllCandidates || idx < visibleCandidateCount}
                />
              )}
            />
          ))}
        </div>
      </Portal>
    );
  }
}

export default StatewideRaces;
